import { EmptyState } from '@/components/EmptyState';
import { Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/PageHeader';

export const Doorman = () => {
  return (
    <div className="space-y-8" data-testid="doorman-page">
      <PageHeader
        title="Portierato"
        subtitle="Gestione del servizio di portierato"
        actions={
          <Button className="bg-white text-primary hover:bg-white/90" data-testid="add-attendance-button">
            Registra Presenza
          </Button>
        }
      />

      <EmptyState
        icon={Clock}
        title="Nessuna presenza registrata"
        description="Inizia a registrare le presenze del portiere"
      />
    </div>
  );
};